
import { StyleSheet } from 'react-native'
import * as v from '../../config/variables'
// import * as colors from '../../config/colors'

const styles = StyleSheet.create({
  container: {
    // paddingVertical: variables.SPACE_SM
  },
  questionText: {
    textAlign: 'center',
  },
  actionBox: {
    marginTop: v.SPACE_SM,
    flexDirection: 'row',
    paddingHorizontal: v.SPACE_XS,
    justifyContent: 'center',
  },
  bottomActionBox: {
    marginTop: v.SPACE_LG,
    marginBottom: v.SPACE_LG,
    paddingHorizontal: v.SPACE_SM,
  },
  buttonHalfWidth: {
    width: 174,
    marginHorizontal: v.SPACE_XS,
  },
  successBox: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: v.SPACE_MD,
  },
  successContent: {
    paddingHorizontal: 0,
    marginLeft: v.SPACE_SM,
    flexShrink: 1,
  },
})

export default styles
